import cx from 'classnames'

import './styles.scss'

export const Badge = ({
  count,
  color = 'blue',
  onClick,
  title,
  children,
  ...other
}) => {
  const badgeClass = cx({
    'badge': true,
    'red': color === 'red',
    'teal': color === 'teal',
    'purple': color === 'purple',
    'dark-blue': color === 'darkBlue',
    'grey': color === 'grey'
  })

  return (
    <div
      className='nh-badge'
      onClick={onClick}
      {...other}
      aria-hidden='true'
    >
      <span className='title'>
        {title}
        {children}
      </span>
      <div className='badge-wrapper'>
        <span className={badgeClass}>{count}</span>
      </div>
    </div>
  )
}
